import React from 'react'
import type { IconProps } from '@strata-monorepo/shared-ui/types/Svg'

export default function ArrowDownExpand({ classNames, ...props }: IconProps): React.ReactElement {
  return (
    <svg
      width='8'
      height='5'
      viewBox='0 0 8 5'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={classNames}
      {...props}
    >
      <path
        d='M3.93335 4.80002C3.81934 4.80002 3.70774 4.77828 3.59857 4.7348C3.48939 4.69132 3.39204 4.62683 3.30653 4.54132L0.249283 1.48408C0.0830945 1.31789 0 1.11209 0 0.866683C0 0.621272 0.0830945 0.415472 0.249283 0.249283C0.415472 0.0830939 0.621272 0 0.866683 0C1.11209 0 1.31789 0.0830939 1.48408 0.249283L3.93335 2.69855L6.38262 0.249283C6.54881 0.0830939 6.75461 0 7.00002 0C7.24543 0 7.45123 0.0830939 7.61742 0.249283C7.78361 0.415472 7.8667 0.621272 7.8667 0.866683C7.8667 1.11209 7.78361 1.31789 7.61742 1.48408L4.56017 4.54132C4.47466 4.62683 4.37731 4.69132 4.26813 4.7348C4.15896 4.77828 4.04736 4.80002 3.93335 4.80002Z'
        fill='currentColor'
      />
    </svg>
  )
}
